import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue overflow-auto" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "text-lg pb-4 font-semibold" }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "flex items-center justify-between mb-4" }
const _hoisted_7 = { class: "font-bold text-nucleus-primaryBlue" }
const _hoisted_8 = { class: "bg-nucleus-white" }
const _hoisted_9 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = { class: "px-4 pt-6" }
const _hoisted_12 = { class: "border-b pt-2 mb-4" }
const _hoisted_13 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_14 = { class: "border-b pt-2 mb-4" }
const _hoisted_15 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_16 = { class: "border-b pt-2 mb-4" }
const _hoisted_17 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_18 = { class: "border-b pt-2 mb-4" }
const _hoisted_19 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }
const _hoisted_20 = { class: "pb-6" }
const _hoisted_21 = { class: "text-sm text-nucleus-text" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1 text-black"
}
const _hoisted_23 = {
  key: 1,
  class: "mt-1 text-nucleus-error"
}
const _hoisted_24 = { class: "pb-6" }
const _hoisted_25 = { class: "text-sm text-nucleus-text" }
const _hoisted_26 = {
  key: 1,
  class: "text-sm text-nucleus-text"
}
const _hoisted_27 = { class: "pb-6" }
const _hoisted_28 = { class: "text-sm text-nucleus-text" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "border-b pt-2 mb-4" }
const _hoisted_31 = { class: "text-lg pb-2 text-nucleus-grey font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!
  const _component_ModalDeleteCheck = _resolveComponent("ModalDeleteCheck")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!
  const _component_HeaderMini = _resolveComponent("HeaderMini")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_InfoItem = _resolveComponent("InfoItem")!
  const _component_TextLinkBasic = _resolveComponent("TextLinkBasic")!
  const _component_InfoItemList = _resolveComponent("InfoItemList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.confirm)
      ? (_openBlock(), _createBlock(_component_ModalConfirmation, {
          key: 0,
          text: _ctx.confirm.text,
          onYes: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirm.yes())),
          onNo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm.no()))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.errorHeading || _ctx.errorContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 1,
          heading: _ctx.errorHeading,
          content: _ctx.errorContent,
          fixed: _ctx.errorFixed,
          onCloseError: _cache[2] || (_cache[2] = ($event: any) => {
        _ctx.errorHeading = '';
        _ctx.errorContent = '';
      })
        }, null, 8, ["heading", "content", "fixed"]))
      : _createCommentVNode("", true),
    (_ctx.deleteCheck)
      ? (_openBlock(), _createBlock(_component_ModalDeleteCheck, {
          key: 2,
          text: _ctx.$t('global.defaults.tenancy', 1),
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteCheck = false)),
          onDeleteMe: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteMe()))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.addUsageShow)
      ? (_openBlock(), _createBlock(_component_ModalWrapper, {
          key: 3,
          onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addUsageShow = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              class: "pt-2 mb-4 relative",
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUsage && _ctx.addUsage(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", {
                class: "absolute -top-6 -right-6 text-xl p-2 hover:text-nucleus-primaryBlue transition leading-none cursor-pointer icon-close rounded-full",
                title: _ctx.$t('titles.close'),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addUsageShow = false))
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pages.tenancy.addCredits")), 1),
              _createVNode(_component_Input, {
                id: "usage-add",
                value: _ctx.creditsToAdd,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.creditsToAdd) = $event)),
                "update:value": _ctx.validateCredits(_ctx.creditsToAdd),
                "input-type": "number",
                label: _ctx.$t('inputs.credits.label'),
                min: "0",
                "max-length": _ctx.inputMaxLengths.credits,
                placeholder: _ctx.$t('inputs.credits.placeholder'),
                required: ""
              }, null, 8, ["value", "update:value", "label", "max-length", "placeholder"]),
              _createVNode(_component_Button, {
                type: "submit",
                name: _ctx.$t('buttons.addCredits'),
                disabled: !_ctx.creditsToAdd || !_ctx.validateCredits(_ctx.creditsToAdd) || _ctx.loading,
                loading: _ctx.loading
              }, null, 8, ["name", "disabled", "loading"])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_HeaderMini, {
            name: _ctx.tenancy.name,
            to: { name: 'tenancies' },
            "can-delete": true,
            "can-edit": true,
            "can-deactivate": true,
            "can-add-usage": true,
            state: _ctx.tenancy.state,
            "no-menu": false,
            text: _ctx.$t('global.defaults.tenancy', 1),
            onDeleteCheck: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteCheck = true)),
            onEdit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editTenancy())),
            onDeactivate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.confirmDeactivateTenancy())),
            onActivate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.activateTenancy())),
            onAddUsage: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addUsageShow = true))
          }, null, 8, ["name", "state", "text"]),
          _createVNode(_component_HeaderShadow),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("global.defaults.status")) + " ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.mapState(_ctx.tenancy.state)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-tenancy" }, null, -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.tenancy.name), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.tenancyStatus'),
                  value: _ctx.mapState(_ctx.tenancy.state)
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.created'),
                  value: new Date(Date.parse(_ctx.tenancy.createdOn)).toString()
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.internalId'),
                  value: _ctx.tenancy.tenantId
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.Region'),
                  value: 
                _ctx.regions.find((v) => v.id.toString() === _ctx.tenancy.region)?.name ||
                _ctx.regions[0].name
              
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.language'),
                  value: 
                _ctx.languages.find((v) => v.id.toString() === _ctx.tenancy.language)
                  ?.name || _ctx.languages[0].name
              
                }, null, 8, ["heading", "value"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("pages.tenancy.allowance")), 1)
                ]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.currentLicense'),
                  value: _ctx.tenancy.license
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.expiryDate'),
                  value: _ctx.getDate(_ctx.tenancy.licenseExpiry)
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.hoursUsed'),
                  value: _ctx.getHoursUsed()
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.balance'),
                  value: _ctx.getHoursLeft()
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('inputs.allowanceWarningThreshold.label'),
                  value: 
                _ctx.tenancy.allowanceWarningThreshold ||
                _ctx.defaults.allowanceWarningThreshold
              
                }, null, 8, ["heading", "value"]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("pages.tenancy.contactDetails")), 1)
                ]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('inputs.name.label'),
                  value: _ctx.tenancy.contact.name
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('inputs.email.label'),
                  value: _ctx.tenancy.contact.email
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('inputs.phone.label'),
                  value: _ctx.tenancy.contact.phone
                }, null, 8, ["heading", "value"]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("pages.tenancy.sessionSettings")), 1)
                ]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('inputs.maxBroadcasts.label'),
                  value: _ctx.tenancy.maxBroadcasts || _ctx.defaults.maxBroadcasts
                }, null, 8, ["heading", "value"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pages.tenancy.serverConnection")), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("pages.tenancy.connectionStatus")), 1),
                  (_ctx.connectionStatus.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.connectionStatus.status), 1))
                    : _createCommentVNode("", true),
                  (_ctx.connectionStatus.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.connectionStatus.error), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TextLinkBasic, {
                    class: "mt-6",
                    name: _ctx.$t('pages.tenancy.checkConnection'),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.testConnection()))
                  }, null, 8, ["name"])
                ]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.apiVersion'),
                  value: 
                _ctx.apiVersionOptions.find(
                  (v) => v.id.toString() === _ctx.tenancy.api.version
                )?.name || _ctx.apiVersionOptions[0].name
              
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.apiUsername'),
                  value: _ctx.tenancy.api.username
                }, null, 8, ["heading", "value"]),
                _createVNode(_component_InfoItem, {
                  heading: _ctx.$t('pages.tenancy.vpnUrl'),
                  value: _ctx.tenancy.vpnServer
                }, null, 8, ["heading", "value"]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("pages.tenancy.vpnCertificate")), 1),
                  (!_ctx.downloadPending)
                    ? (_openBlock(), _createBlock(_component_TextLinkBasic, {
                        key: 0,
                        class: "mt-6",
                        name: _ctx.$t('pages.tenancy.download'),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.downloadVpnCert()))
                      }, null, 8, ["name"]))
                    : _createCommentVNode("", true),
                  (_ctx.downloadPending)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t("pages.tenancy.generating")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("pages.tenancy.mediaIp")), 1),
                  (_ctx.tenancy.elasticIps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenancy.elasticIps, (allocation) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: allocation.publicIp,
                            class: "mt-1 text-black"
                          }, _toDisplayString(allocation.publicIp), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.tenancy.elasticIps)
                    ? (_openBlock(), _createBlock(_component_TextLinkBasic, {
                        key: 1,
                        class: "mt-6",
                        name: _ctx.$t('pages.tenancy.reserve'),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmReserveIps()))
                      }, null, 8, ["name"]))
                    : _createCommentVNode("", true),
                  (_ctx.tenancy.elasticIps)
                    ? (_openBlock(), _createBlock(_component_TextLinkBasic, {
                        key: 2,
                        class: "mt-6",
                        name: _ctx.$t('pages.tenancy.release'),
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.confirmReleaseIps()))
                      }, null, 8, ["name"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("pages.tenancy.userAccess")), 1)
                ]),
                _createVNode(_component_InfoItemList, {
                  heading: _ctx.$t('pages.tenancy.ipWhitelist'),
                  list: 
                _ctx.tenancy.ipWhitelist ? _ctx.tenancy.ipWhitelist : ['No restriction']
              
                }, null, 8, ["heading", "list"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}